export const KEY = 'lib_potential_client'
